import { onWindowUnload } from '../../common/helpers/window'
import { getEventsToForwardToCompanion } from '../../core/integrations-helpers'
import { type EventsNamespaceDefinition } from '../../extensions/extension-config'
import { type EventAdapterPayload, type EventBusPrivate } from '../namespaces/event-bus'
import { type ExternalInterfaceCallback, type EventBusMessage, type EventBusMessagePayload } from './external-interface'
import { getExternalInterface } from './external-interface-adapter'

const shouldSendEventToExternalInterface = (namespace: string, eventName: string, callerId?: string) => {
  if (typeof callerId === 'undefined') {
    if (getExternalInterface().isCompanion) {
      return true
    } else if (getExternalInterface().isIntegration) {
      const reducePredicate = (result: boolean, item: EventsNamespaceDefinition) => {
        if (item.namespace === namespace) {
          if (item.eventNames && item.eventNames.length) {
            return !!item.eventNames.find(itemEventName => itemEventName === eventName)
          }

          return true
        }
        return result
      }

      return getEventsToForwardToCompanion().reduce(reducePredicate, false)
    }
  }

  return false
}

const eventAdapter = (payload: EventAdapterPayload) => {
  if (shouldSendEventToExternalInterface(payload.namespace, payload.eventName, payload.callerId)) {
    const msg: EventBusMessage = {
      type: 'eventbus',
      payload: {
        namespace: payload.namespace,
        eventName: payload.eventName,
        args: payload.args,
      },
    }
    getExternalInterface().send(msg)
  }
}

export const addExternalInterfaceEventAdapter = (eventBus: EventBusPrivate) => {
  eventBus.setEventAdapter(eventAdapter)

  const handleExternalEvents: ExternalInterfaceCallback<EventBusMessagePayload> = payload => {
    eventBus.emitEvent(payload)
  }

  getExternalInterface().addCallback('eventbus', handleExternalEvents)

  onWindowUnload(() => {
    eventBus.removeEventAdapter()
    getExternalInterface().removeCallback('eventbus', handleExternalEvents)
  })
}
